export default {
  methods: {
    toast(message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type,
      });
    },
  },
}